<div class="row">
  <div class="label-container">Structure</div>
  <div class="composition-container">

    <div class="selector-container">
      <mat-form-field class="selector" subscriptSizing="dynamic">
        <mat-label>{{ label() }}</mat-label>
        <mat-select [formControl]="structureControl">
          @for (group of structureData(); track group) {
            <mat-optgroup [label]="group.source">
              @for (id of group.identifiers; track id) {
                <mat-option [value]="id">{{ id }}</mat-option>
              }
            </mat-optgroup>
          }
        </mat-select>
      </mat-form-field>

    </div>


    <div class="structure-container" #viewer></div>

  </div>
</div>












